import React from 'react';
import { ConfirmPopup } from './../../../common/popup';
import { connect } from 'react-redux';
import { REDUCER_NAME, togglePopupResponseSave } from './../reducer';

class Response extends React.Component {
  render() {
    const {
      messages,
      confirm,
      isShowMessage,
      maxParam,
      invalidName,
    } = this.props;
    let title = 'stockScreener.screenerMessage.warningTitle';
    if (maxParam) {
      title = 'stockScreener.screenerMessage.warnMaxParam';
    }
    if (invalidName) {
      title = 'stockScreener.screenerMessage.errorEmptyname';
    }

    return (
      <div className="custom-modal">
        <ConfirmPopup
          iconName={'icon-warning'}
          title={title}
          messages={messages}
          isShow={isShowMessage}
          enabledApply={false}
          enabledCancel={false}
          confirm={confirm}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    messages: state[REDUCER_NAME].save.messages,
    isShowMessage: state[REDUCER_NAME].save.isShowMessage,
    maxParam: state[REDUCER_NAME].maxParam,
    invalidName: state[REDUCER_NAME].invalidName,
  };
};

const mapDispatchToProps = {
  confirm: togglePopupResponseSave,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Response);
